var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-over"}),_vm._v(" "),_c('div',[(!_vm.headerNotShow)?_c('HeadBar',{staticClass:"header-class"}):_c('header-two',{staticClass:"header-class"}),_vm._v(" "),_c('AppMain',{staticClass:"app-class",style:({'height':'calc('+(_vm.height - 112)+'px)'})})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d0fdcac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layoutIndustry/layout.vue
// module id = null
// module chunks = 